module.exports = __webpack_public_path__ + "img/抖音.37b5715d.png";